import React from 'react';

import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import MapIcon from '@mui/icons-material/Map';

import { closePoiListingMenu } from '../../store/actions/poiListingActions';
import { CustomIconButton } from '../Button/CustomIconButton';
import { hideAlert } from '../../store/actions/alertActions';


export const GoBackMapButton = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const closePoiListing = async () => {
    dispatch(closePoiListingMenu());
    dispatch(hideAlert());
  };

  return (
    <CustomIconButton id='poi_listing_close' ariaControls="poi-disclosure" tooltip={t('poiListing.map')} ariaLabel={t('poiListing.map')} callback={closePoiListing} icon={MapIcon}></CustomIconButton>
  );
};